/**
 * @generated SignedSource<<0ada96d010dec2ca2a5ab6a31a3994b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NaturalLanguageToggle$data = {
  readonly atlassianIntelligenceAction: {
    readonly __typename: "JiraAccessAtlassianIntelligenceFeature";
    readonly isAccessible: boolean | null | undefined;
  } | {
    readonly __typename: "JiraContactOrgAdminToEnableAtlassianIntelligence";
  } | {
    readonly __typename: "JiraEnableAtlassianIntelligenceDeepLink";
    readonly link: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly " $fragmentType": "NaturalLanguageToggle";
};
export type NaturalLanguageToggle$key = {
  readonly " $data"?: NaturalLanguageToggle$data;
  readonly " $fragmentSpreads": FragmentRefs<"NaturalLanguageToggle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "atlassianIntelligenceProductFeature"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "NaturalLanguageToggle",
  "selections": [
    {
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "feature",
              "variableName": "atlassianIntelligenceProductFeature"
            }
          ],
          "kind": "ObjectValue",
          "name": "atlassianIntelligenceProductFeatureInput"
        },
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "kind": "LinkedField",
      "name": "atlassianIntelligenceAction",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "isAccessible"
            }
          ],
          "type": "JiraAccessAtlassianIntelligenceFeature"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "link"
            }
          ],
          "type": "JiraEnableAtlassianIntelligenceDeepLink"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/)
          ],
          "type": "JiraContactOrgAdminToEnableAtlassianIntelligence"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};
})();

(node as any).hash = "a6a94f58ee797a7c26fc7f5907f4ab86";

export default node;
